// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__37KzR","alert":"SettungsInbox_alert__2wUc5"};